module.exports = __webpack_public_path__ + "static/media/clockIconUnit.22de30ab.svg";